import { FormGroup, Input, Label, Button } from "reactstrap";
import { useLocation } from "react-router-dom";

import useData from "./data";
import AddMembers from "./AddMembers";

export default function CreateEditExpenseGroup() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("groud_id");

  const {
    name,
    setName,
    description,
    setDescription,
    members,
    setMembers,
    handleSubmit,
    loading,
  } = useData(id);

  return (
    <div className="p-2 mt-2  ">
      <h6>Create Expense Group</h6>
      <FormGroup>
        <Label for="name">Name</Label>
        <Input
          type="text"
          id="name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          required
        />
      </FormGroup>
      <FormGroup>
        <Label for="description">Description</Label>
        <Input
          type="textarea"
          id="description"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          required
        />
      </FormGroup>
      <hr />
      {!id && <AddMembers members={members} setMembers={setMembers} />}{" "}
      {id ? (
        <Button
          type="submit"
          color="warning"
          className="w-100 mt-3"
          onClick={handleSubmit}
          disabled={loading}
        >
          <i className="bx bx-edit mr-1"></i>
          Update
        </Button>
      ) : (
        <Button
          type="submit"
          color="primary"
          className="w-100 mt-3"
          onClick={handleSubmit}
          disabled={loading || members.length === 0}
        >
          <i className="bx bx-plus mr-1"></i>
          Create
        </Button>
      )}
    </div>
  );
}
